<template>
  <div class="view-member-area-students">
    <div class="py-6">
      <div class="row justify-content-between">
        <div class="d-flex align-items-center col-lg-3 mb-5 mb-lg-0">
          <span class="table-quantity-counter mr-5">
            Total: {{ pagination.count }}
          </span>
          <button class="btn p-0 table-refresh" @click="refresh">
            <i class="fa-solid fa-refresh" />
          </button>
        </div>
        <div class="col-xl-7 col-lg-8">
          <div class="d-flex justify-content-between mb-3">
            <search-filter
              placeholder="E-mail, nome do aluno"
              @search="searching"
              class="mb-3 mb-lg-0 flex-fill"
              filterButtonText=""
              :showResultsDropdown="false"
              :newDesign="true"
            >
            </search-filter>

            <filter-button
              button-class="btn-40 btn-square ml-3 btn-new-outline-primary btn-sm"
            >
              <template #default="{ close }">
                <students-filter
                  v-model="params.is_enable"
                  @close="close"
                  @submit="dispatch"
                />
              </template>
            </filter-button>

            <div v-if="isProductActive" class="d-none d-lg-block ml-3">
              <button
                class="btn btn-sm btn-outline-primary btn-40 btn-square btn-new-outline-primary"
                @click="dialog.import = true"
              >
                <i class="fa-solid fa-file-import" />
              </button>
            </div>

            <div class="d-none d-lg-block ml-3">
              <b-dropdown
                class="btn btn-outline-primary btn-40 px-0 btn-new-outline-primary"
              >
                <template #button-content>
                  <i class="fa-solid fa-download mx-3" />
                  <div class="vertical-line"></div>
                  <i class="fa-solid fa-angle-down mx-3" />
                </template>
                <b-dropdown-item @click="exportStudents('csv')"
                  >Exportar em CSV</b-dropdown-item
                >
                <b-dropdown-item @click="exportStudents('excel')"
                  >Exportar em Excel</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div v-if="isProductActive" class="d-none d-lg-flex pl-3">
              <button
                class="btn btn-primary btn-new-primary px-5 btn-size btn-40"
                @click="() => openStudentModal()"
              >
                <i class="fa-solid fa-plus mr-3" />
                Adicionar Aluno
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="d-lg-none d-flex">
        <button
          v-if="isProductActive"
          class="btn btn-sm btn-outline-primary btn-40 mr-3 btn-square btn-new-outline-primary"
          @click="dialog.import = true"
        >
          <i class="fa-solid fa-file-import" />
        </button>

        <b-dropdown
          class="btn btn-outline-primary btn-40 btn-new-outline-primary mr-3"
        >
          <template #button-content>
            <i class="fa-solid fa-download mx-3" />
            <div class="vertical-line"></div>
            <i class="fa-solid fa-angle-down mx-3" />
          </template>
          <b-dropdown-item @click="exportStudents('csv')"
            >Exportar em CSV</b-dropdown-item
          >
          <b-dropdown-item @click="exportStudents('excel')"
            >Exportar em Excel</b-dropdown-item
          >
        </b-dropdown>

        <div class="d-flex flex-fill">
          <button
            class="btn btn-primary btn-new-primary btn-40 btn-block"
            @click="() => openStudentModal()"
          >
            <i class="fa-solid fa-plus mr-3 ml-3" />
            <div class="mr-3">Adicionar Aluno</div>
          </button>
        </div>
      </div>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div
        v-else-if="!students.length && isProductActive"
        class="container centering text-center my-6"
      >
        <img
          class="d-block mb-9 mx-auto"
          src="@/assets/images/home/welcome.png"
        />
        <h5>Bem-vindo(a) a área de membros do seu produto</h5>
        <div class="text-secondary mb-9">
          Para começar, cadastre o primeiro aluno.
        </div>
        <button class="btn btn-primary" @click="() => openStudentModal()">
          Cadastrar Aluno
        </button>
      </div>

      <div v-else>
        <!-- desktop area -->
        <data-table
          class="d-none d-lg-block"
          :columns="columns"
          :data="students"
          :columnsFr="'1.54fr 1fr 1fr 1.54fr 1fr 0.4fr 0.2fr'"
          :newDesign="true"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column">
              <div class="name-cell">
                {{ formatLongText(item.name) }}
              </div>
              {{ formatLongText(item.email) }}
            </div>
            <div class="d-flex align-items-center text-truncate">
              {{ formatHumanDate(item.date_joined) }}
            </div>
            <div class="d-flex align-items-center text-truncate">
              {{ item.last_login }}
            </div>
            <div class="d-flex align-items-center text-truncate">
              <b-progress
                :value="item.progress"
                max="100"
                class="mr-3 w-100"
              ></b-progress>
              <span> {{ item.progress }} % </span>
            </div>
            <div class="d-flex align-items-center text-truncate">
              {{
                (item.expires_in || "Ilimitado")
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div>
              <div class="d-flex align-items-center text-truncate">
                <span
                  :class="{
                    'active-badge': item.is_enable,
                    'inactive-badge': !item.is_enable
                  }"
                  v-html="statusHtml(item)"
                >
                </span>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions(item)"
                @edit="openStudentModal(item)"
                @details-progress="getProgressDetail(item)"
                @enable="enablestudent(item)"
                @disable="disablestudent(item)"
                @change-password="changePassword(item)"
                @reset-password="resetPassword(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- desktop area -->
        <!-- mobile area -->
        <data-table
          class="d-lg-none"
          :columns="columns.slice(0, 2).map(() => '')"
          :data="students"
          :firstColumnFr="2"
          :lastColumnFr="0.1"
          :newDesign="true"
        >
          <template #default="{ item }">
            <div class="d-flex flex-column text-left pl-3 py-5">
              <div class="d-flex align-items-center text-truncate pb-3">
                <strong class="mr-3">Nome:</strong>
                {{ item.name }}
              </div>
              <div class="d-flex align-items-center text-truncate pb-3">
                <strong class="mr-3">Adicionado em:</strong>
                {{ formatHumanDate(item.date_joined) }}
              </div>
              <div class="d-flex align-items-center text-truncate pb-3">
                <strong class="mr-3">Progresso:</strong>
                <b-progress
                  :value="item.progress"
                  max="100"
                  class="mr-3 w-100"
                ></b-progress>
                <span style="width: 40px; font-size: 13px;">
                  {{ item.progress }} %
                </span>
              </div>
              <div class="d-flex align-items-center">
                <strong class="mr-3">Status:</strong>
                <div
                  :class="{
                    'active-badge': item.is_enable,
                    'inactive-badge': !item.is_enable
                  }"
                  v-html="statusHtml(item)"
                ></div>
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <actions-dropdown
                :left="false"
                :right="true"
                :actions="actions(item)"
                @details-progress="getProgressDetail(item)"
                @edit="openStudentModal(item)"
                @enable="enablestudent(item)"
                @disable="disablestudent(item)"
                @change-password="changePassword(item)"
                @reset-password="resetPassword(item)"
              />
            </div>
          </template>
        </data-table>
        <!-- mobile area -->
      </div>
      <div class="d-flex justify-content-center">
        <paginator
          :pagination="pagination"
          @on-update="onPaginationUpdate"
          v-show="students.length"
        />
      </div>
    </div>
    <responsive-modal v-model="dialog.changePassword">
      <change-password-modal
        :student="editedItem"
        @close="dialog.changePassword = false"
      />
    </responsive-modal>

    <responsive-modal v-if="isProductActive" v-model="dialog.import" size="lg">
      <import-modal
        v-if="dialog.import"
        @close="dialog.import = false"
        @refresh="refresh"
      />
    </responsive-modal>

    <responsive-modal v-model="dialog.student" size="lg" ref="studentModal">
      <students-modal
        ref="modalContent"
        :student="editedItem"
        @close="dialog.student = false"
        @success="studentOnSuccess"
        :studentErrors="studentErrors"
        class="p-5"
      />
    </responsive-modal>

    <responsive-modal v-model="dialog.progressDetails" size="lg">
      <progress-details-modal
        :selectedStudent="selectedStudent"
        @close="dialog.progressDetails = false"
        class="p-5"
      />
    </responsive-modal>
  </div>
</template>

<script>
import ChangePasswordModal from "@/components/product/students/ChangePasswordModal";
import StudentsFilter from "@/components/product/students/Filter";
import ImportModal from "@/components/product/students/ImportModal";
import ProgressDetailsModal from "@/components/product/students/ProgressDetailsModal.vue";
import StudentsModal from "@/components/product/students/StudentsModal";

import { clearObject, toHumanDate } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {
    ImportModal,
    StudentsModal,
    ChangePasswordModal,
    StudentsFilter,
    ProgressDetailsModal
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersStudents", ["students", "pagination"]),
    isProductActive() {
      return this.product.status === "active";
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          title: "Alunos"
        }
      ];
    }
  },
  data() {
    return {
      params: {
        search: "",
        offset: null,
        is_enable: ""
      },
      exportLoading: false,
      loading: false,
      search: "",
      editedItem: null,
      columns: [
        "Nome",
        "Adicionado em",
        "Último acesso",
        "Progresso",
        "Expiração",
        "Status",
        ""
      ],
      dialog: {
        import: false,
        student: false,
        changePassword: false,
        progressDetails: false
      },
      selectedStudent: null,
      studentErrors: {}
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    studentOnSuccess() {
      this.dialog.student = false;
      this.refresh();
    },
    openStudentModal(item = {}) {
      this.editedItem = item;
      this.dialog.student = true;
    },
    statusHtml(item) {
      return (item.not_expire || item.is_enable) && !item.canceled_at
        ? "<span>Ativo</span>"
        : "<span>Inativo</span>";
    },
    formatLongText(txt) {
      if (txt) {
        return txt.length > 26 ? `${txt.slice(0, 26)}...` : `${txt}`;
      }
      return "-";
    },
    formatHumanDate(date) {
      return toHumanDate(date);
    },
    actions(item) {
      const actions = [
        {
          text: "Detalhes do progresso",
          class: "",
          icon: "fa-solid fa-circle-info",
          confirmation: {
            enable: false
          },
          event: "details-progress"
        },
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        },
        {
          text: "Alterar senha",
          class: "",
          icon: "fa-solid fa-key",
          confirmation: {
            enable: false
          },
          event: "change-password"
        },
        {
          text: "Reenviar acesso",
          class: "",
          icon: "fa-solid fa-envelope",
          confirmation: {
            enable: true,
            text: `Tem certeza que deseja reenviar o acesso do aluno ${item.name}?`
          },
          event: "reset-password"
        }
      ];
      if (item.is_enable) {
        actions.push({
          text: "Desativar",
          class: "text-danger",
          icon: "fa-solid fa-power-off",
          confirmation: {
            enable: true,
            text: `Tem certeza que deseja desativar o aluno ${item.name}?`
          },
          event: "disable"
        });
      } else {
        actions.push({
          text: "Ativar",
          class: "text-success",
          icon: "fa-solid fa-check",
          confirmation: {
            enable: new Date(item.expires_in) > new Date(),
            text: `Tem certeza que deseja ativar o aluno ${item.name}?`
          },
          event: "enable"
        });
      }
      return actions;
    },
    async exportStudents(format) {
      try {
        this.exportLoading = true;

        let payload = { ...this.params, type: format };
        if (payload.is_enable == "active") {
          payload.is_enable = true;
        } else if (payload.is_enable == "inactive") {
          payload.is_enable = false;
        } else {
          delete payload.is_enable;
        }

        delete payload.product_id;

        let href;

        const { data: CSVContent } = await this.$store.dispatch(
          "membersStudents/getAll",
          {
            product_id: this.$route.params.id,
            params: { ...payload, export: true }
          }
        );

        if (format === "excel") {
          href = URL.createObjectURL(CSVContent);
        } else {
          href = `data:text/csv;charset=utf-8,${CSVContent.replaceAll(
            "#",
            "%23"
          )}`;
        }

        var a = document.createElement("a");
        a.href = href;
        a.setAttribute(
          "download",
          `students_${moment().format("YYYYMMDD")}_${moment().unix()}.${
            format === "excel" ? "xlsx" : "csv"
          }`
        );
        a.click();
      } catch (e) {
      } finally {
        this.exportLoading = false;
      }
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.refresh();
    },
    enablestudent(student) {
      if (new Date() >= new Date(student.expires_in)) {
        this.editedItem = student;
        this.studentErrors = {
          expires_in: ["Selecione uma nova data para reativar esse aluno."]
        };

        this.dialog.student = true;
      } else
        this.$store
          .dispatch("membersStudents/enable", student.id)
          .then(this.refresh);
    },
    disablestudent(student) {
      this.$store
        .dispatch("membersStudents/disable", student.id)
        .then(this.refresh);
    },
    resetPassword(student) {
      this.$store
        .dispatch("membersStudents/resetPassword", {
          student_id: student.id,
          product_id: this.$route.params.id
        })
        .then(this.refresh);
    },
    changePassword(student) {
      this.editedItem = student;
      this.dialog.changePassword = true;
    },
    searching(v) {
      this.params.search = v;
      this.dispatch();
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      let payload = { ...this.params };
      if (payload.is_enable == "active") {
        payload.is_enable = true;
      } else if (payload.is_enable == "inactive") {
        payload.is_enable = false;
      } else {
        delete payload.is_enable;
      }

      this.loading = true;
      this.$store
        .dispatch("membersStudents/getAll", {
          product_id: this.$route.params.id,
          params: clearObject(payload)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProgressDetail(student) {
      this.selectedStudent = student;
      this.dialog.progressDetails = true;
    }
  },
  watch: {
    "dialog.student"(v) {
      if (!v && Object.keys(this.studentErrors).length) this.studentErrors = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.view-member-area-students {
  .btn {
    &:not(.btn-sm) {
      min-height: 28px;
    }
  }

  a {
    text-decoration: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #9155ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }

  .name-cell {
    color: rgba(59, 59, 74, 0.9);
    line-height: 20px;
  }

  .progress {
    height: 0.5rem;
    background-color: rgba(219, 221, 230, 0.85);
  }

  ::v-deep.progress-bar {
    background-color: rgba(184, 136, 255, 0.86);
  }

  .card {
    border: none;
    background: rgba(255, 255, 255, 0.16);
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    color: #57586be0;
    padding: 20px 24px;
    .text-secondary {
      color: #77788edd;
    }
  }
}

::v-deep .btn {
  &.dropdown-toggle {
    background-color: unset !important;
    min-height: 40px;
    padding: 0;

    &::after {
      content: none;
    }
  }
}

::v-deep .btn-secondary {
  background: rgba(119, 120, 142, 0.08);
  border-color: transparent;
  color: rgba(87, 88, 107, 0.88);
}

body.modal-open {
  div.component-view-container {
    filter: blur(40px);
  }
}

::v-deep .actions-dropdown .dropdown-toggle i,
::v-deep .btn-outline-dark {
  border: none;
  color: rgba(119, 120, 142, 0.87);
}

.btn-size {
  min-width: 180px;
}

::v-deep .dropdown-toggle {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr auto 1fr;
}

.vertical-line {
  height: 50%;
  border-right: 1px solid #8636fe;
}
</style>
